<template>
  <div style="position: fixed; top: 0; left: -100000px; width: 1000px">
    <div id="payroll-requisition-paper">
      <div class="page" v-for="item, index in data" :key="index">
        <table>
          <thead>
            <tr>
              <th>创建时间</th>
              <th>确认时间</th>
              <th>发货时间</th>
              <th>订单号</th>
              <th>Shipment No.</th>
              <th>售后单号</th>
              <th>售后类型</th>
              <th>货币</th>
              <th>吊牌价</th>
              <th>供货价</th>
              <th>运费</th>
              <th>赔付金额</th>
              <th>快递单号</th>
              <th>结算状态</th>
              <th>订单状态</th>
              <th>店铺名称</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="childItem, childIndex in item.detailResVos" :key="childIndex">
              <td>{{ childItem.createTime }}</td>
              <td>{{ childItem.confirmedTime }}</td>
              <td>{{ childItem.shippedTime }}</td>
              <td>{{ childItem.orderId }}</td>
              <td>{{ childItem.shipmentNo }}</td>
              <td>{{ childItem.afterSaleNum }}</td>
              <td>{{ childItem.afterSaleOrderWayType }}</td>
              <td>{{ childItem.currency }}</td>
              <td>{{ childItem.retailPrice }}</td>
              <td>{{ childItem.supplyPrice }}</td>
              <td>{{ childItem.pushShipAmount }}</td>
              <td>{{ childItem.pushRefundAmount }}</td>
              <td>{{ childItem.trackingNumber }}</td>
              <td>{{ childItem.settlementStatus }}</td>
              <td>{{ childItem.orderStatus }}</td>
              <td>{{ childItem.vendorName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import printJS from 'print-js';

export default {
  name: 'PayrollRequisitionPaper',
  props: {
    data: Array,
  },
  methods: {
    print() {
      const that = this;
      printJS({
        printable: 'payroll-requisition-paper',
        type: 'html',
        style: `
                @page {
                  margin: 5mm;
                }
                * { margin: 0; padding: 0 }
                body { color: #000 }
                .page { page-break-before: auto; page-break-after: always; }
                .table {
                  width: 100%;
                  border-collapse:collapse;
                }
                .cell {
                  font-size: 10px;
                }
                table {
                  width: 100%;
                }
                th {
                  background-color: #ccc;
                }
                table, th, td {
                  font-size: 10px;
                  text-align: center;
                  border: 1px solid black;
                  border-collapse: collapse; /* 移除单元格之间的间隔 */
                }
                .table td,
                .table th{
                  padding: 5pt;
                  vertical-align: top;
                  text-align: left;
                }
                .table td.nopadding { padding: 0 }
                .table td.vab { vertical-align: bottom; }
                .bt { border-top: 1pt solid #ccc }
                .bb { border-bottom: 1pt solid #ccc }
                .f10 { font-size: 10pt; font-weight: 300 }
                .f12 { font-size: 12pt }
                .f14 { font-size: 14pt }
                .f16 { font-size: 16pt }
                .f18 { font-size: 18pt }
                .bold { font-weight: bold }
                .txtc { text-align: center }
                .txtr { text-align: right }
                .title { padding: 40pt 80pt 20pt }
                .mt2 { margin-top: 2pt }
                .mt5 { margin-top: 5pt }
                .mt10 { margin-top: 10pt }
                .mt20 { margin-top: 20pt }
                .pl10 { padding-left: 10pt }
                .pr10 { padding-right: 10pt }
                .pl5 { padding-left: 5pt }
                .pr5 { padding-right: 5pt }
                .pt20 { padding-top: 20pt }
                .pb20 { padding-bottom: 20pt }
                .pt10 { padding-top: 10pt }
                .pb10 { padding-bottom: 10pt }
                .pt5 { padding-top: 5pt }
                .pb5 { padding-bottom: 5pt }
                .flex {
                  display: flex;
                  justify-content: space-between;
                }
                .flex-alc { align-items: center; }
                .value {
                  display: inline-block;
                  width: 150pt;
                }
              `,
        // maxWidth: 800,
        onPrintDialogClose: () => {
          that.$emit('close');
        },
        targetStyle: [],
        targetStyles: [],
        font_size: 'auto',
        // ignoreElements: [],
        font: 'Roboto, Arial',
        // honorMarginPadding: false,
        imageStyle: 'max-width: 100%;max-height: 200pt',
      });
    },
  },
};
</script>
